import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Heading, Text } from '@chakra-ui/react';
import parse from 'html-react-parser';
import React, { forwardRef } from 'react';
var CustomText = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _props$textStyle;

  var as = props.as,
      _props$bold = props.bold,
      bold = _props$bold === void 0 ? false : _props$bold,
      children = props.children,
      _props$isProse = props.isProse,
      isProse = _props$isProse === void 0 ? false : _props$isProse,
      _props$textVariant = props.textVariant,
      textVariant = _props$textVariant === void 0 ? 'p' : _props$textVariant,
      rest = _objectWithoutPropertiesLoose(props, ["as", "bold", "children", "isProse", "textVariant"]);

  if (!children) return null;

  var normalizeString = function normalizeString(childrenContent) {
    if (typeof childrenContent === 'object') return children; // TODO : improve this to catch all string beginning by p, even if they have props

    if (childrenContent.slice(0, 3) === '<p>' && childrenContent.slice(childrenContent.length - 4, childrenContent.length) === '</p>') {
      return parse(childrenContent.slice(3, childrenContent.length - 4), {
        trim: true
      });
    }

    return parse(childrenContent, {
      trim: true
    });
  };

  var normalizedChildren = normalizeString(children);
  var textStyle = ((_props$textStyle = props.textStyle) !== null && _props$textStyle !== void 0 ? _props$textStyle : isProse) ? "prose." + textVariant : "ui." + textVariant;

  switch (textVariant) {
    case 'headline':
    case 'h1':
      return /*#__PURE__*/React.createElement(Heading, Object.assign({
        as: as !== null && as !== void 0 ? as : 'h1',
        textStyle: textStyle
      }, rest, {
        ref: forwardedRef
      }), normalizedChildren);

    case 'section':
    case 'h2':
      return /*#__PURE__*/React.createElement(Heading, Object.assign({
        as: as !== null && as !== void 0 ? as : 'h2',
        textStyle: textStyle
      }, rest, {
        ref: forwardedRef
      }), normalizedChildren);

    case 'h3':
      return /*#__PURE__*/React.createElement(Heading, Object.assign({
        as: as !== null && as !== void 0 ? as : 'h3',
        textStyle: textStyle
      }, rest, {
        ref: forwardedRef
      }), normalizedChildren);

    case 'h4':
      return /*#__PURE__*/React.createElement(Heading, Object.assign({
        as: as !== null && as !== void 0 ? as : 'h4',
        textStyle: textStyle
      }, rest, {
        ref: forwardedRef
      }), normalizedChildren);

    case 'h5':
      return /*#__PURE__*/React.createElement(Heading, Object.assign({
        as: as !== null && as !== void 0 ? as : 'h5',
        textStyle: textStyle
      }, rest, {
        ref: forwardedRef
      }), normalizedChildren);

    case 'h6':
      return /*#__PURE__*/React.createElement(Heading, Object.assign({
        textStyle: textStyle
      }, rest, {
        ref: forwardedRef
      }), normalizedChildren);

    case 'p':
      return /*#__PURE__*/React.createElement(Text, Object.assign({
        as: as !== null && as !== void 0 ? as : 'p',
        textStyle: textStyle
      }, rest, {
        ref: forwardedRef
      }), normalizedChildren);

    default:
      var exhaustiveCheck = textVariant;
      throw new Error("There is a case missing in the switch. Unexpected: " + exhaustiveCheck);
  }
});
export default CustomText;